import React from "react";
import Index from "../component/Index";

export default function PrimaryButton(props) {
  return (
    <>
      <Index.Box className="primary-btn-main-user">
        <Index.Button
          className={props.className}
          onClick={props.onClick}
          disabled={props.disabled}
          variant={props.variant}
          disableRipple
        >
          {props.btnLabel}
        </Index.Button>
      </Index.Box>
    </>
  );
}
